import script from "./CInputRadio.vue?vue&type=script&lang=js"
export * from "./CInputRadio.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__